(function () {
  'use strict';
  /* global $, angular, clicky, clicky_custom, _gaq */

  angular.module('Milestone').controller('ebookDownloadCtrl', ['$scope', '$http', '$window', 'localStorageService', 'UserDataService',
    function ($scope, $http, $window, localStorageService, UserDataService) {
      UserDataService.getUser().then(function (user) {
        $scope.signup = angular.copy(user);
        $scope.signup.origin = window.location.href;
        $scope.signup.type = 'signUpEbookDownload';
        $scope.signup.form_id = 177545;
        $scope.signup.guid = window.getLassoGuid();
        $scope.signup._form_id = 'ebook_download';
      });

      $scope.signup = {};

      $scope.localStorageKey = 'ebookDownload';

      console.log(localStorageService.get($scope.localStorageKey));
      if (localStorageService.get($scope.localStorageKey)) {
        $scope.hideForm = true;
        $scope.showMessage = true;
      } else {
        $scope.hideForm = false;
        $scope.showMessage = false;
      }

      $scope.showLoader = false;
      $scope.triedSubmit = false;

      $scope.checkFormValidation = function (form) {
        $scope.triedSubmit = true;

        if (!form.$valid) {
          return;
        }

        processEbookDownloadForm();
      };

      function processEbookDownloadForm () {
        $scope.hideForm = true;
        $scope.showLoader = true;
        $http({
          method: 'POST',
          url: '/form/to-database',
          data: $.param($scope.signup), // pass in data as strings
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          } // set the headers so angular passing info as form data (not request payload)
        })
          .success(function (data) {
            $scope.showLoader = false;
            if (data.status === 'success') {
              // Tie lead id and email to clicky analytics data
              clicky_custom.visitor = {
                lead_id: data.id,
                email: data.email,
                signup: '1'
              };

              clicky_custom.goal = {
                name: 'Quick Signup'
              };

              // Log action in clicky
              clicky.goal('2672'); // Logs a "quick-signup" goal hit in clicky
              clicky.log('/quick-signup/thank-you'); // Logs a fake page hit in clicky

              // Fire off a Facebook Pixel Code (Lead)
              fbq('track', 'Lead');

              // Fire off a Google Analytics goal hit
              _gaq.push(['_trackPageview', '/ajax-goals/quick-signup-ebook-download']);

              $scope.message = data.message;
              $scope.showMessage = true;

              localStorageService.set($scope.localStorageKey, $scope.signup.email);

              $window.open('/pdfs/ebook-download/milestone-ebook.pdf', '_blank');
            } else {
              $scope.message = data.message;
              $scope.showMessage = true;
            }
          });
      }
    }
  ]);
})();
